<template>
  <div class="card-manage">
    <div class="page-title">卡号卡密管理</div>

    <div class="toolbar">
      <div class="toolbar-left">
        <button class="btn-add" @click="openAdd">+ 添加卡密</button>
        <button class="btn-export" @click="exportExcel">导出表格数据</button>
        <button class="btn-batch-del" :disabled="selectedIds.length === 0" @click="batchDelete">批量删除 ({{ selectedIds.length }})</button>
      </div>
      <div class="filter-box">
        <select v-model="filterStatus">
          <option value="">全部状态</option>
          <option value="active">已激活</option>
          <option value="inactive">未激活</option>
        </select>
        <select v-model="filterShip">
          <option value="">全部物流</option>
          <option value="shipped">已发货</option>
          <option value="unshipped">未发货</option>
        </select>
        <input v-model="search" type="text" placeholder="搜索卡号..." />
      </div>
    </div>

    <div class="table-wrap">
      <table class="table">
        <thead>
          <tr>
            <th style="width:40px;"><input type="checkbox" :checked="allSelected" @change="toggleSelectAll"></th>
            <th>所属版本</th>
            <th>编号</th>
            <th>卡号</th>
            <th>卡密</th>
            <th>对应套餐</th>
            <th>状态</th>
            <th>激活时间</th>
            <th>发货状态</th>
            <th>操作</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(c, idx) in cards" :key="c.id" :class="{ selected: selectedIds.includes(c.id) }">
            <td><input type="checkbox" :checked="selectedIds.includes(c.id)" @change="toggleSelect(c.id)"></td>
            <td><span class="site-tag" :class="normalizeSite(c.site)">{{ siteLabel(c.site) }}</span></td>
            <td>{{ (page - 1) * pageSize + idx + 1 }}</td>
            <td class="mono">{{ c.cardNo }}</td>
            <td class="mono">{{ c.cardKey }}</td>
            <td>{{ c.pkg }}</td>
            <td><span class="status-tag" :class="c.status">{{ c.status === 'active' ? '已激活' : '未激活' }}</span></td>
            <td>{{ formatTime(c.activeTime) }}</td>
            <td><span class="status-tag" :class="c.shipStatus">{{ c.shipStatus === 'shipped' ? '已发货' : '未发货' }}</span></td>
            <td>
              <button class="btn-action" @click="editCard(c)">编辑</button>
              <button class="btn-action del" @click="delCard(c.id)">删除</button>
              <button class="btn-action" @click="showDetail(c)">详情</button>
              <button class="btn-action" :disabled="c.status !== 'active' && c.shipStatus !== 'shipped'" @click="showLogistics(c)">物流</button>
              <button class="btn-action ship" :class="{ disabled: c.status !== 'active' }" :disabled="c.status !== 'active'" @click="goShip(c)">去发货</button>
            </td>
          </tr>
          <tr v-if="loading"><td colspan="10" style="text-align:center;">加载中...</td></tr>
          <tr v-if="!loading && cards.length === 0"><td colspan="10" style="text-align:center;color:#999;">当前版本暂无卡密，请点击「添加卡密」创建</td></tr>
        </tbody>
      </table>
    </div>

    <div class="pagination" v-if="total > 0">
      <span class="total-count">共 {{ total }} 条</span>
      <template v-if="totalPages > 1">
        <button :disabled="page === 1" @click="page--; fetchCards()">&lt;</button>
        <span v-for="p in totalPages" :key="p" class="page-num" :class="{ cur: p === page }" @click="page = p; fetchCards()">{{ p }}</span>
        <button :disabled="page === totalPages" @click="page++; fetchCards()">&gt;</button>
      </template>
    </div>

    <!-- 添加/编辑弹窗 -->
    <div class="modal-overlay" v-if="showModal" @click.self="showModal = false">
      <div class="modal-card">
        <div class="modal-header">
          <span>{{ detailMode ? '卡密详情' : editMode ? '编辑卡密' : '添加卡密' }}</span>
          <span class="close" @click="showModal = false">✕</span>
        </div>
        <div class="modal-body">
          <template v-if="detailMode && detailCard">
            <div class="detail-row"><span class="detail-label">所属版本</span><span>{{ siteLabel(detailCard.site) }}</span></div>
            <div class="detail-row"><span class="detail-label">卡号</span><span class="mono">{{ detailCard.cardNo }}</span></div>
            <div class="detail-row"><span class="detail-label">卡密</span><span class="mono">{{ detailCard.cardKey }}</span></div>
            <div class="detail-row"><span class="detail-label">对应套餐</span><span>{{ detailCard.pkg }}</span></div>
            <div class="detail-row"><span class="detail-label">状态</span><span class="status-tag" :class="detailCard.status">{{ detailCard.status === 'active' ? '已激活' : '未激活' }}</span></div>
            <div class="detail-row"><span class="detail-label">物流单号</span><span>{{ detailCard.logistics || '-' }}</span></div>
            <div class="detail-row"><span class="detail-label">激活时间</span><span>{{ formatTime(detailCard.activeTime) }}</span></div>
            <div class="detail-section-title">收货地址</div>
            <div class="detail-row"><span class="detail-label">收件人</span><span>{{ detailCard.name || '-' }}</span></div>
            <div class="detail-row"><span class="detail-label">手机号</span><span>{{ detailCard.phone || '-' }}</span></div>
            <div class="detail-row"><span class="detail-label">省/市</span><span>{{ detailCard.province ? detailCard.province + ' ' + detailCard.city : '-' }}</span></div>
            <div class="detail-row"><span class="detail-label">详细地址</span><span>{{ detailCard.detailAddr || '-' }}</span></div>
            <div class="detail-section-title">客户备注</div>
            <div class="detail-row"><span class="detail-label">备注</span><span>{{ detailCard.remark || '-' }}</span></div>
          </template>
          <template v-else-if="editMode">
            <div class="field">
              <label>所属版本</label>
              <select v-model="form.site">
                <option v-for="s in siteOptions" :key="s.value" :value="s.value">{{ s.label }}</option>
              </select>
            </div>
            <div class="field">
              <label>卡号</label>
              <input v-model="form.cardNo" type="text" placeholder="请输入卡号" />
            </div>
            <div class="field">
              <label>卡密</label>
              <input v-model="form.cardKey" type="text" placeholder="请输入卡密" />
            </div>
            <div class="field">
              <label>对应套餐</label>
              <select v-model="form.pkg">
                <option value="">请选择套餐</option>
                <option value="套餐A">套餐A</option>
                <option value="套餐B">套餐B</option>
                <option value="套餐C">套餐C</option>
                <option value="套餐D">套餐D</option>
              </select>
            </div>
            <div class="detail-section-title">收货信息</div>
            <div class="field">
              <label>收件人</label>
              <input v-model="form.name" type="text" placeholder="请输入收件人姓名" />
            </div>
            <div class="field">
              <label>手机号</label>
              <input v-model="form.phone" type="text" placeholder="请输入手机号" />
            </div>
            <div class="field">
              <label>省份</label>
              <input v-model="form.province" type="text" placeholder="请输入省份" />
            </div>
            <div class="field">
              <label>城市</label>
              <input v-model="form.city" type="text" placeholder="请输入城市" />
            </div>
            <div class="field">
              <label>详细地址</label>
              <input v-model="form.detailAddr" type="text" placeholder="请输入详细地址" />
            </div>
            <div class="field">
              <label>备注</label>
              <input v-model="form.remark" type="text" placeholder="请输入备注（选填）" />
            </div>
          </template>
          <template v-else>
            <div class="add-tabs">
              <button class="add-tab" :class="{ active: addMode === 'single' }" @click="addMode = 'single'; resetAddForm()">单条添加</button>
              <button class="add-tab" :class="{ active: addMode === 'excel' }" @click="addMode = 'excel'; resetAddForm()">Excel批量添加</button>
            </div>
            <template v-if="addMode === 'single'">
              <div class="field">
                <label>所属版本</label>
                <select v-model="form.site">
                  <option v-for="s in siteOptions" :key="s.value" :value="s.value">{{ s.label }}</option>
                </select>
              </div>
              <div class="field">
                <label>卡号</label>
                <input v-model="form.cardNo" type="text" placeholder="请输入卡号" />
              </div>
              <div class="field">
                <label>卡密</label>
                <input v-model="form.cardKey" type="text" placeholder="请输入卡密" />
              </div>
            </template>
            <template v-if="addMode === 'excel'">
              <div class="field">
                <label>所属版本</label>
                <select v-model="form.site">
                  <option v-for="s in siteOptions" :key="s.value" :value="s.value">{{ s.label }}</option>
                </select>
              </div>
              <div class="excel-upload">
                <label class="excel-label">
                  <input type="file" accept=".xlsx,.xls" @change="handleExcel" ref="fileInput" />
                  <span class="excel-btn">选择Excel文件</span>
                </label>
                <span class="excel-tip">仅支持 .xlsx / .xls，第一列卡号、第二列卡密</span>
                <button class="btn-template" @click="downloadTemplate">下载模板</button>
              </div>
              <div class="excel-error" v-if="excelError">{{ excelError }}</div>
              <div class="excel-msg" v-if="importMsg" :class="importMsg.type">{{ importMsg.text }}</div>
              <div class="excel-preview" v-if="excelPreview.length">
                <div class="preview-header">预览（共 {{ excelPreview.length }} 条）</div>
                <div class="preview-table-wrap">
                  <table class="preview-table">
                    <thead><tr><th>#</th><th>卡号</th><th>卡密</th></tr></thead>
                    <tbody>
                      <tr v-for="(r, idx) in excelPreviewPage" :key="idx">
                        <td>{{ (excelPage - 1) * 6 + idx + 1 }}</td>
                        <td class="mono">{{ r.cardNo }}</td>
                        <td class="mono">{{ r.cardKey }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div class="preview-page" v-if="excelTotalPages > 1">
                  <button :disabled="excelPage === 1" @click="excelPage--">&lt;</button>
                  <span v-for="p in excelTotalPages" :key="p" class="page-num" :class="{ cur: p === excelPage }" @click="excelPage = p">{{ p }}</span>
                  <button :disabled="excelPage === excelTotalPages" @click="excelPage++">&gt;</button>
                </div>
              </div>
            </template>
          </template>
        </div>
        <div class="modal-footer">
          <template v-if="detailMode">
            <button class="btn-cancel" @click="showModal = false">关闭</button>
          </template>
          <template v-else-if="editMode">
            <button class="btn-save" @click="saveCard">保存</button>
            <button class="btn-cancel" @click="showModal = false">取消</button>
          </template>
          <template v-else>
            <button class="btn-save" @click="saveAdd" :disabled="(addMode === 'excel' && !excelPreview.length) || saving">{{ saving ? '保存中...' : '保存' }}</button>
            <button class="btn-cancel" @click="showModal = false">取消</button>
          </template>
        </div>
      </div>
    </div>

    <!-- 提示弹窗 -->
    <Modal :visible="msgModal.show" :title="msgModal.title" @close="closeMsgModal">
      <p style="white-space: pre-wrap; margin: 0;">{{ msgModal.message }}</p>
      <template #footer>
        <button class="btn-save" style="margin-left:0;" @click="closeMsgModal">确定</button>
      </template>
    </Modal>

    <!-- 确认弹窗 -->
    <Modal :visible="confirmModal.show" title="提示" :closeOnOverlay="false" @close="cancelConfirm">
      <p style="margin: 0;">{{ confirmModal.message }}</p>
      <template #footer>
        <button class="btn-cancel" @click="cancelConfirm">取消</button>
        <button class="btn-save" style="background:#e74c3c;" @click="okConfirm">确定</button>
      </template>
    </Modal>

    <!-- 去发货弹窗 -->
    <div class="modal-overlay" v-if="showShipModal" @click.self="showShipModal = false">
      <div class="modal-card ship-modal">
        <div class="modal-header">
          <span>去发货</span>
          <span class="close" @click="showShipModal = false">✕</span>
        </div>
        <div class="modal-body">
          <template v-if="shipStep === 1 && shipCard">
            <div class="ship-confirm-section">
              <div class="detail-row"><span class="detail-label">所选套餐</span><span>{{ shipCard.pkg }}</span></div>
              <div class="detail-row"><span class="detail-label">收件人</span><span>{{ shipCard.name || '-' }}</span></div>
              <div class="detail-row"><span class="detail-label">联系电话</span><span>{{ shipCard.phone || '-' }}</span></div>
              <div class="detail-row"><span class="detail-label">收货地址</span><span>{{ shipCard.province ? shipCard.province + shipCard.city + shipCard.detailAddr : '-' }}</span></div>
              <div class="detail-row"><span class="detail-label">备注</span><span>{{ shipCard.remark || '-' }}</span></div>
            </div>
          </template>
          <template v-if="shipStep === 2">
            <div v-for="(s, sIdx) in shipList" :key="sIdx" class="ship-line">
              <div class="ship-line-header">
                <span>快递 #{{ sIdx + 1 }}</span>
                <button v-if="shipList.length > 1" class="btn-remove-ship" @click="removeShipLine(sIdx)">移除</button>
              </div>
              <div class="field">
                <label>快递公司</label>
                <select v-model="s.courier">
                  <option value="">请选择快递公司</option>
                  <option v-for="c in courierOptions" :key="c.value" :value="c.value">{{ c.label }}</option>
                </select>
              </div>
              <div class="field">
                <label>物流单号</label>
                <input v-model="s.logistics" type="text" placeholder="请输入快递单号" />
              </div>
            </div>
            <button class="btn-add-ship" @click="addShipLine">+ 添加快递</button>
          </template>
        </div>
        <div class="modal-footer">
          <template v-if="shipStep === 1">
            <button class="btn-save" @click="shipStep = 2">确认信息</button>
            <button class="btn-cancel" @click="showShipModal = false">取消</button>
          </template>
          <template v-if="shipStep === 2">
            <button class="btn-save" @click="confirmShip">发货</button>
            <button class="btn-cancel" @click="shipStep = 1">上一步</button>
          </template>
        </div>
      </div>
    </div>

    <!-- 物流轨迹弹窗 -->
    <div class="modal-overlay" v-if="showLogisticsModal" @click.self="showLogisticsModal = false">
      <div class="modal-card logistics-modal">
        <div class="modal-header">
          <span>物流详情</span>
          <span class="close" @click="showLogisticsModal = false">✕</span>
        </div>
        <div class="modal-body">
          <template v-if="logisticsLoading">
            <p class="loading-tip">查询中...</p>
          </template>
          <template v-else>
            <div class="detail-row"><span class="detail-label">收件人</span><span>{{ logisticsInfo.name || '-' }}</span></div>
            <div class="detail-row"><span class="detail-label">手机号</span><span>{{ logisticsInfo.phone || '-' }}</span></div>

            <div v-if="logisticsShipments.length === 0" class="empty-tip">暂无发货记录</div>

            <div v-for="(s, sIdx) in logisticsShipments" :key="s.id || sIdx" class="shipment-card">
              <div class="shipment-header">
                <span class="shipment-label">快递 #{{ sIdx + 1 }}</span>
                <button class="btn-del-ship" @click="delShipment(s.id)">删除</button>
              </div>
              <div class="detail-row"><span class="detail-label">快递单号</span><span class="mono">{{ s.logistics }}</span></div>
              <div class="detail-row"><span class="detail-label">快递公司</span><span>{{ s.expName || courierLabel(s.courierType) || '-' }}</span></div>
              <div class="detail-row"><span class="detail-label">物流状态</span><span :class="shipStatusClass(s)">{{ s.statusStr || '已发货' }}</span></div>
              <div v-if="s.error" class="detail-row"><span class="detail-label">查询结果</span><span class="error-text">{{ s.error }}</span></div>
              <div v-if="s.traces && s.traces.length" class="tracking-section">
                <div class="detail-section-title">物流轨迹</div>
                <div class="timeline">
                  <div class="timeline-item" v-for="(t, tIdx) in s.traces" :key="tIdx" :class="{ latest: tIdx === 0 }">
                    <div class="timeline-dot"></div>
                    <div class="timeline-content">
                      <div class="timeline-time">{{ t.time }}</div>
                      <div class="timeline-text">{{ t.desc }}</div>
                    </div>
                  </div>
                </div>
              </div>
              <p v-else class="empty-tip">暂无物流轨迹</p>
            </div>
          </template>
        </div>
        <div class="modal-footer">
          <button class="btn-cancel" @click="showLogisticsModal = false">关闭</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { api } from '@/utils/api';
import Modal from '@/components/Modal.vue';
import { COURIER_OPTIONS, courierLabel } from '@/utils/courier';
import { SITE_OPTIONS, siteLabel, normalizeSite, getAdminSite } from '@/utils/site';

export default {
  name: 'AdminCardManage',
  components: { Modal },
  data() {
    return {
      courierOptions: COURIER_OPTIONS,
      siteOptions: SITE_OPTIONS,
      search: '',
      filterStatus: '',
      filterShip: '',
      page: 1,
      pageSize: 10,
      total: 0,
      cards: [],
      selectedIds: [],
      loading: false,
      showModal: false,
      editMode: false,
      detailMode: false,
      editId: null,
      detailCard: null,
      showShipModal: false,
      shipStep: 1,
      shipCard: null,
      shipList: [],
      addMode: 'single',
      excelFile: null,
      excelPreview: [],
      excelPage: 1,
      excelError: '',
      importMsg: null,
      saving: false,
      form: { cardNo: '', cardKey: '', site: 'duanwu', pkg: '', courierType: '', logistics: '', name: '', phone: '', province: '', city: '', detailAddr: '', remark: '' },
      msgModal: { show: false, title: '提示', message: '' },
      confirmModal: { show: false, message: '', resolve: null },
      showLogisticsModal: false,
      logisticsLoading: false,
      logisticsCardId: null,
      logisticsInfo: { name: '', phone: '' },
      logisticsShipments: [],
    };
  },
  computed: {
    totalPages() {
      return Math.ceil(this.total / this.pageSize) || 1;
    },
    excelPreviewPage() {
      const start = (this.excelPage - 1) * 6;
      return this.excelPreview.slice(start, start + 6);
    },
    excelTotalPages() {
      return Math.ceil(this.excelPreview.length / 6) || 1;
    },
    allSelected() {
      return this.cards.length > 0 && this.selectedIds.length === this.cards.length;
    },
    logisticsComName() {
      return ''; // handled per-shipment now
    },
    logisticsStatusClass() {
      return ''; // handled per-shipment now
    }
  },
  watch: {
    search() { this.page = 1; this.fetchCards(); },
    filterStatus() { this.page = 1; this.fetchCards(); },
    filterShip() { this.page = 1; this.fetchCards(); },
    page() { this.selectedIds = []; }
  },
  created() {
    this.fetchCards();
  },
  methods: {
    siteLabel(site) {
      return siteLabel(site);
    },
    normalizeSite(site) {
      return normalizeSite(site);
    },
    async fetchCards() {
      this.loading = true;
      const site = getAdminSite();
      const params = new URLSearchParams({
        page: this.page,
        pageSize: this.pageSize,
        site
      });
      if (this.filterStatus) params.set('status', this.filterStatus);
      if (this.filterShip) params.set('shipStatus', this.filterShip);
      if (this.search.trim()) params.set('search', this.search.trim());

      const data = await api.get('/api/admin/cards?' + params.toString());
      if (data.code === 200) {
        this.cards = data.data.cards || [];
        this.total = data.data.total || 0;
      }
      this.loading = false;
    },
    formatTime(t) {
      if (!t) return '-';
      return t.replace('T', ' ').slice(0, 16);
    },
    showMsg(title, message) {
      this.msgModal.title = title;
      this.msgModal.message = message;
      this.msgModal.show = true;
    },
    closeMsgModal() {
      this.msgModal.show = false;
    },
    showConfirm(message) {
      return new Promise((resolve) => {
        this.confirmModal.message = message;
        this.confirmModal.resolve = resolve;
        this.confirmModal.show = true;
      });
    },
    okConfirm() {
      this.confirmModal.show = false;
      if (this.confirmModal.resolve) {
        this.confirmModal.resolve(true);
        this.confirmModal.resolve = null;
      }
    },
    cancelConfirm() {
      this.confirmModal.show = false;
      if (this.confirmModal.resolve) {
        this.confirmModal.resolve(false);
        this.confirmModal.resolve = null;
      }
    },
    openAdd() {
      this.detailMode = false;
      this.editMode = false;
      this.editId = null;
      this.detailCard = null;
      this.addMode = 'single';
      this.excelFile = null;
      this.excelPreview = [];
      this.excelPage = 1;
      this.excelError = '';
      this.importMsg = null;
      this.form = { cardNo: '', cardKey: '', site: getAdminSite(), pkg: '', courierType: '', logistics: '', name: '', phone: '', province: '', city: '', detailAddr: '', remark: '' };
      this.showModal = true;
    },
    resetAddForm() {
      this.form.cardNo = '';
      this.form.cardKey = '';
      this.excelFile = null;
      this.excelPreview = [];
      this.excelPage = 1;
      this.excelError = '';
      this.importMsg = null;
      if (this.$refs.fileInput) this.$refs.fileInput.value = '';
    },
    editCard(c) {
      this.detailMode = false;
      this.editMode = true;
      this.editId = c.id;
      this.detailCard = null;
      this.form = { cardNo: c.cardNo, cardKey: c.cardKey, site: normalizeSite(c.site), pkg: c.pkg, courierType: c.courierType || '', logistics: c.logistics || '', name: c.name || '', phone: c.phone || '', province: c.province || '', city: c.city || '', detailAddr: c.detailAddr || '', remark: c.remark || '' };
      this.showModal = true;
    },
    async exportExcel() {
      const token = sessionStorage.getItem('adminToken');
      const params = new URLSearchParams({ status: 'active', site: getAdminSite() });
      const res = await fetch('/api/admin/cards/export?' + params.toString(), {
        headers: token ? { Authorization: 'Bearer ' + token } : {}
      });
      const blob = await res.blob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'card_data.xlsx';
      a.click();
      URL.revokeObjectURL(url);
    },
    async downloadTemplate() {
      const token = sessionStorage.getItem('adminToken');
      const res = await fetch('/api/admin/cards/template', {
        headers: token ? { Authorization: 'Bearer ' + token } : {}
      });
      const blob = await res.blob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'card_template.xlsx';
      a.click();
      URL.revokeObjectURL(url);
    },
    handleExcel(e) {
      this.excelError = '';
      this.excelFile = null;
      this.excelPreview = [];
      this.excelPage = 1;
      this.importMsg = null;
      const file = e.target.files[0];
      if (!file) return;
      this.excelFile = file;

      const XLSX = require('xlsx');
      const reader = new FileReader();
      reader.onload = (ev) => {
        try {
          const data = new Uint8Array(ev.target.result);
          const wb = XLSX.read(data, { type: 'array' });
          const sheet = wb.Sheets[wb.SheetNames[0]];
          const rows = XLSX.utils.sheet_to_json(sheet, { header: 1 });
          if (rows.length < 2) {
            this.excelError = 'Excel文件内容为空';
            return;
          }
          const result = [];
          for (let i = 1; i < rows.length; i++) {
            const row = rows[i];
            if (!row || !row[0]) continue;
            result.push({ cardNo: String(row[0]).trim(), cardKey: row[1] ? String(row[1]).trim() : '' });
          }
          if (!result.length) {
            this.excelError = '未解析到有效数据';
            return;
          }
          this.excelPreview = result;
        } catch {
          this.excelError = '文件解析失败，请检查文件格式';
        }
      };
      reader.readAsArrayBuffer(file);
    },
    async saveAdd() {
      if (this.addMode === 'single') {
        const { cardNo, cardKey } = this.form;
        if (!cardNo.trim() || !cardKey.trim()) {
          this.showMsg('提示', '请填写卡号和卡密');
          return;
        }
        if (cardNo.trim().length !== 18) {
          this.showMsg('提示', '卡号必须为18位');
          return;
        }
        if (cardKey.trim().length !== 8) {
          this.showMsg('提示', '卡密必须为8位');
          return;
        }
        this.saving = true;
        const data = await api.post('/api/admin/cards', { cardNo: cardNo.trim(), cardKey: cardKey.trim(), site: this.form.site || 'duanwu' });
        this.saving = false;
        if (data.code === 200) {
          this.showModal = false;
          this.fetchCards();
        } else {
          this.showMsg('提示', data.message || '添加失败');
        }
      } else {
        if (!this.excelFile) return;
        this.saving = true;
        const fd = new FormData();
        fd.append('file', this.excelFile);
        fd.append('site', this.form.site || 'duanwu');
        const data = await api.postForm('/api/admin/cards/import', fd);
        this.saving = false;
        if (data.code === 200) {
          const r = data.data;
          this.importMsg = {
            type: 'success',
            text: `导入完成：成功 ${r.imported} 条，跳过 ${r.skipped} 条` + (r.errors && r.errors.length ? '，错误 ' + r.errors.length + ' 条' : '')
          };
          if (r.errors && r.errors.length) {
            this.excelError = r.errors.join('\n');
          }
          this.fetchCards();
        } else {
          const msg = data.message || '导入失败';
          const errs = data.data && data.data.errors;
          this.importMsg = { type: 'error', text: errs && errs.length ? msg + '\n' + errs.join('\n') : msg };
        }
      }
    },
    async saveCard() {
      const { cardNo, cardKey, site, pkg, courierType, logistics, name, phone, province, city, detailAddr, remark } = this.form;
      if (!cardNo.trim() || !cardKey.trim()) {
        this.showMsg('提示', '请填写卡号和卡密');
        return;
      }
      if (cardNo.trim().length !== 18) {
        this.showMsg('提示', '卡号必须为18位');
        return;
      }
      if (cardKey.trim().length !== 8) {
        this.showMsg('提示', '卡密必须为8位');
        return;
      }
      if (phone && !/^1[3-9]\d{9}$/.test(phone.trim())) {
        this.showMsg('提示', '请输入正确的手机号码');
        return;
      }
      const data = await api.put('/api/admin/cards/' + this.editId, {
        cardNo: cardNo.trim(),
        cardKey: cardKey.trim(),
        site: site || 'duanwu',
        pkg,
        courierType,
        logistics: logistics.trim(),
        name: name.trim(),
        phone: phone.trim(),
        province: province.trim(),
        city: city.trim(),
        detailAddr: detailAddr.trim(),
        remark: remark.trim()
      });
      if (data.code === 200) {
        this.showModal = false;
        this.fetchCards();
      } else {
        this.showMsg('提示', data.message || '修改失败');
      }
    },
    toggleSelect(id) {
      const idx = this.selectedIds.indexOf(id);
      if (idx >= 0) {
        this.selectedIds.splice(idx, 1);
      } else {
        this.selectedIds.push(id);
      }
    },
    toggleSelectAll() {
      if (this.allSelected) {
        this.selectedIds = [];
      } else {
        this.selectedIds = this.cards.map(c => c.id);
      }
    },
    async batchDelete() {
      const ok = await this.showConfirm('删除将不可恢复，确定删除选中的 ' + this.selectedIds.length + ' 个卡密及其关联的所有数据吗？');
      if (!ok) return;
      const data = await api.post('/api/admin/cards/batch-delete', { ids: this.selectedIds });
      if (data.code === 200) {
        this.selectedIds = [];
        this.showMsg('提示', '批量删除成功');
        this.fetchCards();
      } else {
        this.showMsg('提示', data.message || '批量删除失败');
      }
    },
    async delCard(id) {
      const ok = await this.showConfirm('删除将不可恢复，确定删除该卡密及其关联数据吗？');
      if (!ok) return;
      const data = await api.del('/api/admin/cards/' + id);
      if (data.code === 200) {
        this.fetchCards();
      } else {
        this.showMsg('提示', data.message || '删除失败');
      }
    },
    showDetail(c) {
      this.detailCard = c;
      this.detailMode = true;
      this.showModal = true;
    },
    goShip(c) {
      if (c.status !== 'active') return;
      this.shipCard = c;
      this.shipStep = 1;
      this.shipList = [{ courier: '', logistics: '' }];
      this.showShipModal = true;
    },
    addShipLine() {
      this.shipList.push({ courier: '', logistics: '' });
    },
    removeShipLine(idx) {
      this.shipList.splice(idx, 1);
    },
    async showLogistics(c) {
      this.logisticsCardId = c.id;
      this.logisticsInfo = { name: c.name || '', phone: c.phone || '' };
      this.logisticsShipments = [];
      this.showLogisticsModal = true;
      this.logisticsLoading = true;
      try {
        const data = await api.get('/api/admin/cards/' + c.id + '/logistics');
        if (data.code === 200) {
          this.logisticsInfo = {
            name: data.data.name || '',
            phone: data.data.phone || ''
          };
          this.logisticsShipments = data.data.shipments || [];
        }
      } catch { /* ignore */ }
      this.logisticsLoading = false;
    },
    courierLabel(type) {
      return courierLabel(type);
    },
    shipStatusClass(s) {
      if (s.statusStr && s.statusStr.includes('签收')) return 'delivered';
      if (s.statusStr) return 'shipping';
      return 'shipping';
    },
    async delShipment(shipId) {
      if (!confirm('确定删除这条物流记录吗？')) return;
      const data = await api.del('/api/admin/ship-records/' + shipId);
      if (data.code === 200) {
        const card = this.cards.find(x => x.id === this.logisticsCardId);
        if (card) {
          await this.showLogistics(card);
        }
      } else {
        this.showMsg('提示', data.message || '删除失败');
      }
    },
    async confirmShip() {
      for (let i = 0; i < this.shipList.length; i++) {
        const s = this.shipList[i];
        if (!s.courier) {
          this.showMsg('提示', '请选择快递 #' + (i + 1) + ' 的快递公司');
          return;
        }
        if (!s.logistics.trim()) {
          this.showMsg('提示', '请输入快递 #' + (i + 1) + ' 的物流单号');
          return;
        }
      }
      const shipments = this.shipList.map(s => ({
        logistics: s.logistics.trim(),
        courierType: s.courier
      }));
      const data = await api.post('/api/admin/cards/' + this.shipCard.id + '/ship', { shipments });
      if (data.code === 200) {
        this.showShipModal = false;
        this.fetchCards();
      } else {
        this.showMsg('提示', data.message || '发货失败');
      }
    }
  }
};
</script>

<style scoped>
.card-manage {
  padding: 20px;
}
.page-title {
  font-size: 22px;
  font-weight: 700;
  color: #1a1a1a;
  margin-bottom: 20px;
}
.toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  gap: 12px;
  flex-wrap: wrap;
}
.toolbar-left {
  display: flex;
  gap: 8px;
  align-items: center;
}
.btn-add {
  padding: 10px 22px;
  background: linear-gradient(135deg, #2ecc71, #27ae60);
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
}
.btn-export {
  padding: 10px 22px;
  background: #fff;
  color: #27ae60;
  border: 1px solid #27ae60;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
  transition: all 0.15s;
}
.btn-export:hover {
  background: #eafdf1;
}
.btn-batch-del {
  padding: 10px 22px;
  background: #fff;
  color: #e74c3c;
  border: 1px solid #e74c3c;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
  transition: all 0.15s;
}
.btn-batch-del:hover:not(:disabled) {
  background: #e74c3c;
  color: #fff;
}
.btn-batch-del:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}
.filter-box {
  display: flex;
  gap: 10px;
  align-items: center;
  flex-wrap: wrap;
}
.filter-box select {
  padding: 10px 12px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  font-size: 14px;
  outline: none;
  background: #fff;
  cursor: pointer;
}
.filter-box select:focus {
  border-color: #27ae60;
}
.filter-box input {
  padding: 10px 14px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  font-size: 14px;
  outline: none;
  width: 200px;
}
.filter-box input:focus {
  border-color: #27ae60;
}
.table-wrap {
  background: #fff;
  border-radius: 12px;
  overflow-x: auto;
  box-shadow: 0 2px 12px rgba(0,0,0,0.04);
}
.table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
  min-width: 800px;
}
.table th {
  text-align: left;
  padding: 12px 10px;
  color: #999;
  font-weight: 500;
  background: #fafafa;
  border-bottom: 1px solid #eee;
}
.table td {
  padding: 12px 10px;
  color: #333;
  border-bottom: 1px solid #f5f5f5;
}
.mono {
  font-family: 'SF Mono', 'Menlo', monospace;
  font-size: 13px;
  color: #555;
}
.status-tag {
  display: inline-block;
  padding: 3px 10px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
}
.status-tag.active { background: #eafdf1; color: #27ae60; }
.status-tag.inactive { background: #f5f5f5; color: #999; }
.status-tag.shipped { background: #eafdf1; color: #27ae60; }
.status-tag.unshipped { background: #f5f5f5; color: #999; }
.site-tag {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 12px;
  white-space: nowrap;
}
.site-tag.duanwu { background: #eafdf1; color: #27ae60; }
.site-tag.zhongqiu { background: #fdedec; color: #c0392b; }
.btn-action {
  padding: 4px 12px;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  background: #fff;
  font-size: 13px;
  cursor: pointer;
  margin-right: 6px;
}
.btn-action:hover { border-color: #27ae60; color: #27ae60; }
.btn-action.ship { border-color: #27ae60; color: #27ae60; }
.btn-action.ship:hover { background: #27ae60; color: #fff; }
.btn-action.ship.disabled { border-color: #e0e0e0; color: #ccc; cursor: not-allowed; }
.btn-action.ship.disabled:hover { background: #fff; color: #ccc; }
.btn-action.del:hover { border-color: #e74c3c; color: #e74c3c; }
tr.selected { background: #fef5f5; }
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 6px;
  margin-top: 16px;
}
.total-count {
  font-size: 13px;
  color: #999;
  margin-right: 12px;
}
.pagination button {
  width: 32px;
  height: 32px;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  background: #fff;
  cursor: pointer;
}
.page-num {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  color: #666;
}
.page-num.cur {
  background: #27ae60;
  color: #fff;
}
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}
.modal-card {
  width: 420px;
  max-width: 90vw;
  max-height: 90vh;
  background: #fff;
  border-radius: 12px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  background: #fafafa;
  font-size: 16px;
  font-weight: 600;
  flex-shrink: 0;
}
.close {
  cursor: pointer;
  font-size: 18px;
  color: #999;
}
.modal-body {
  padding: 20px;
  overflow-y: auto;
  flex: 1;
}
.field {
  margin-bottom: 14px;
}
.field label {
  display: block;
  font-size: 14px;
  color: #333;
  margin-bottom: 6px;
}
.field input, .field select, .field textarea {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  font-size: 14px;
  outline: none;
  box-sizing: border-box;
}
.field textarea {
  resize: vertical;
  font-family: inherit;
}
.field input:focus, .field select:focus, .field textarea:focus {
  border-color: #27ae60;
}
.detail-row {
  display: flex;
  align-items: center;
  padding: 10px 0;
  border-bottom: 1px solid #f5f5f5;
  font-size: 14px;
}
.detail-label {
  width: 70px;
  color: #999;
  flex-shrink: 0;
}
.detail-section-title {
  font-size: 14px;
  font-weight: 600;
  color: #27ae60;
  padding: 12px 0 6px;
  margin-top: 8px;
  border-top: 1px solid #f0f0f0;
}
.ship-confirm-section {
  padding: 10px 0;
}
.ship-modal {
  width: 440px;
}
.add-tabs {
  display: flex;
  gap: 0;
  margin-bottom: 18px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #e0e0e0;
}
.add-tab {
  flex: 1;
  padding: 10px 0;
  border: none;
  background: #fafafa;
  font-size: 14px;
  cursor: pointer;
  color: #666;
  transition: all 0.15s;
}
.add-tab.active {
  background: #27ae60;
  color: #fff;
  font-weight: 600;
}
.excel-upload {
  text-align: center;
  padding: 10px 0;
}
.excel-label {
  display: inline-block;
}
.excel-label input[type="file"] {
  display: none;
}
.excel-btn {
  display: inline-block;
  padding: 10px 28px;
  border: 2px dashed #27ae60;
  border-radius: 10px;
  color: #27ae60;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s;
}
.excel-btn:hover {
  background: #eafdf1;
}
.excel-tip {
  display: block;
  margin-top: 10px;
  font-size: 12px;
  color: #bbb;
}
.btn-template {
  display: inline-block;
  margin-top: 10px;
  padding: 6px 18px;
  background: #fff;
  border: 1px solid #27ae60;
  border-radius: 6px;
  color: #27ae60;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.15s;
}
.btn-template:hover {
  background: #eafdf1;
}
.excel-error {
  text-align: center;
  color: #e74c3c;
  font-size: 13px;
  margin-top: 8px;
  white-space: pre-wrap;
}
.excel-msg {
  text-align: center;
  font-size: 14px;
  font-weight: 600;
  margin-top: 8px;
  padding: 6px 12px;
  border-radius: 6px;
}
.excel-msg.success { color: #27ae60; background: #eafdf1; }
.excel-msg.error { color: #e74c3c; background: #fdeaea; }
.excel-preview { margin-top: 14px; }
.preview-header { font-size: 13px; font-weight: 600; color: #333; margin-bottom: 8px; }
.preview-table-wrap { max-height: 200px; overflow-y: auto; border: 1px solid #eee; border-radius: 6px; }
.preview-table { width: 100%; border-collapse: collapse; font-size: 13px; }
.preview-table th { background: #fafafa; padding: 8px 10px; color: #999; font-weight: 500; border-bottom: 1px solid #eee; position: sticky; top: 0; }
.preview-table td { padding: 6px 10px; border-bottom: 1px solid #f5f5f5; }
.preview-page { display: flex; justify-content: center; align-items: center; gap: 4px; margin-top: 8px; }
.preview-page button { width: 26px; height: 26px; border: 1px solid #e0e0e0; border-radius: 4px; background: #fff; cursor: pointer; font-size: 12px; }
.modal-footer {
  padding: 14px 20px;
  text-align: right;
  border-top: 1px solid #f0f0f0;
  flex-shrink: 0;
}
.btn-save {
  padding: 9px 24px;
  background: #27ae60;
  color: #fff;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  margin-left: 10px;
}
.btn-cancel {
  padding: 9px 24px;
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
}

/* 物流弹窗 */
.logistics-modal { width: 480px; }
.loading-tip { text-align: center; color: #999; padding: 20px 0; }
.empty-tip { text-align: center; color: #bbb; font-size: 14px; padding: 16px 0; }
.shipping { color: #e67e22; font-weight: 600; }
.delivered { color: #27ae60; font-weight: 600; }
.error-text { color: #e74c3c; font-weight: 500; }

.tracking-section { margin-top: 8px; }
.timeline {
  position: relative;
  padding: 8px 0 0 12px;
}
.timeline::before {
  content: '';
  position: absolute;
  left: 4px;
  top: 12px;
  bottom: 8px;
  width: 2px;
  background: #e0e0e0;
}
.timeline-item {
  position: relative;
  padding: 8px 0 8px 16px;
}
.timeline-item:last-child { padding-bottom: 0; }
.timeline-dot {
  position: absolute;
  left: -11px;
  top: 12px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #ddd;
  border: 2px solid #fff;
  box-shadow: 0 0 0 1px #ddd;
}
.timeline-item.latest .timeline-dot {
  background: #27ae60;
  box-shadow: 0 0 0 3px rgba(39,174,96,0.2);
}
.timeline-content { font-size: 13px; }
.timeline-time { color: #999; font-size: 12px; margin-bottom: 2px; }
.timeline-text { color: #333; line-height: 1.5; }
.timeline-item.latest .timeline-text { color: #27ae60; font-weight: 500; }

.btn-action.disabled { color: #ccc; cursor: not-allowed; border-color: #eee; }
.btn-action.disabled:hover { color: #ccc; border-color: #eee; }

/* shipment cards in logistics modal */
.shipment-card {
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  padding: 12px;
  margin-bottom: 12px;
}
.shipment-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
  padding-bottom: 6px;
  border-bottom: 1px solid #f0f0f0;
}
.shipment-label {
  font-weight: 600;
  font-size: 14px;
  color: #27ae60;
}
.btn-del-ship {
  padding: 4px 12px;
  border: 1px solid #e74c3c;
  border-radius: 4px;
  background: #fff;
  color: #e74c3c;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.15s;
}
.btn-del-ship:hover {
  background: #e74c3c;
  color: #fff;
}
.add-shipment-section {
  margin-top: 16px;
  padding-top: 12px;
  border-top: 1px solid #f0f0f0;
}

/* multi-ship in 去发货 modal */
.ship-line {
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  padding: 12px;
  margin-bottom: 10px;
}
.ship-line-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 4px;
  font-size: 13px;
  font-weight: 600;
  color: #27ae60;
}
.btn-remove-ship {
  padding: 2px 10px;
  border: 1px solid #e74c3c;
  border-radius: 4px;
  background: #fff;
  color: #e74c3c;
  font-size: 12px;
  cursor: pointer;
}
.btn-remove-ship:hover {
  background: #e74c3c;
  color: #fff;
}
.btn-add-ship {
  width: 100%;
  padding: 8px;
  border: 1px dashed #27ae60;
  border-radius: 8px;
  background: #fafdfb;
  color: #27ae60;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.15s;
}
.btn-add-ship:hover {
  background: #eafdf1;
}
</style>
